import { EmptyState } from './EmptyState.component';

export default EmptyState;
